import ApiService from './ApiService';

export interface FeedbackPayload {
  ratings: number;
  user_feedback: string;
}

export interface FeedbackResponse {
  success: boolean;
  message: string;
  feedback_id?: string;
}

class FeedbackService {
  public async submitFeedback(
    requestPayload: FeedbackPayload,
  ): Promise<FeedbackResponse> {
    const { success, data, error } = await ApiService.post<
      FeedbackPayload,
      FeedbackResponse
    >(`/feedback`, requestPayload);

    if (success) {
      return data as FeedbackResponse;
    } else {
      throw new Error(error || 'Failed to submit feedback');
    }
  }

  public async dismissFeedback(): Promise<FeedbackResponse> {
    const { success, data, error } = await ApiService.post<
      undefined,
      FeedbackResponse
    >(`/feedback/dismiss`, undefined);

    if (success) {
      return data as FeedbackResponse;
    } else {
      throw new Error(error || 'Failed to dismiss feedback');
    }
  }
}

export default new FeedbackService();
